type Tga = (a: string, b: string, ...args: string[]) => void
class EventTracker {
  private ga: Tga
  constructor(ga: Tga = () => {}) {
    this.ga = ga
  }

  sendEvent(...args: string[]): void {
    return this.ga('send', 'event', ...args)
  }
}

export default EventTracker
